module.exports = __webpack_public_path__ + "img/story-02.a15faaf6.png";